import { useState, useEffect, useCallback } from 'react'
import { cuentasContablesApi } from '../api/caja'
import Boton from '../components/Boton'

const EMPTY = { codigo: '', nombre: '', pagable: true, cobrable: true, activo: true }

export default function CuentasContablesPage() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(null)
  const [form, setForm] = useState(EMPTY)
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState(null)

  const cargar = useCallback(async () => {
    setLoading(true)
    const { data } = await cuentasContablesApi.listar()
    setRows(data); setLoading(false)
  }, [])
  useEffect(() => { cargar() }, [cargar])

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }))
  const abrirNuevo = () => { setForm(EMPTY); setErr(null); setModal('new') }
  const abrirEdit = (r) => { setForm({ ...EMPTY, ...r }); setErr(null); setModal(r) }

  const guardar = async () => {
    setSaving(true); setErr(null)
    try {
      const payload = { ...form }
      if (modal === 'new') await cuentasContablesApi.crear(payload)
      else await cuentasContablesApi.actualizar(modal.id, payload)
      setModal(null); await cargar()
    } catch (e) {
      setErr(e.response?.data?.message || 'No se pudo guardar')
    } finally { setSaving(false) }
  }

  const desactivar = async (r) => {
    if (!window.confirm(`Dar de baja la cuenta ${r.codigo}?`)) return
    await cuentasContablesApi.eliminar(r.id); await cargar()
  }

  return (
    <div style={st.wrap}>
      <div style={st.head}>
        <h1 style={st.h1}>Cuentas contables</h1>
        <Boton variante="primary" onClick={abrirNuevo}>＋ Nueva cuenta</Boton>
      </div>
      <p style={st.muted}>Las cuentas mapean a Presea (el código viaja en el envío de la minuta). Editá los códigos provisorios por los reales.</p>
      <div style={st.card}>
        <table style={st.table}>
          <thead><tr>
            <th style={st.th}>Código</th><th style={st.th}>Nombre</th><th style={st.th}>Pagable</th><th style={st.th}>Cobrable</th><th style={st.th}>Estado</th><th style={st.th}></th>
          </tr></thead>
          <tbody>
            {loading && <tr><td colSpan={6} style={st.empty}>Cargando...</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={6} style={st.empty}>Sin cuentas.</td></tr>}
            {rows.map(r => (
              <tr key={r.id} style={st.tr}>
                <td style={st.td}><code style={st.code}>{r.codigo}</code></td>
                <td style={st.td}>{r.nombre}</td>
                <td style={st.td}>{r.pagable ? '✓' : '—'}</td>
                <td style={st.td}>{r.cobrable ? '✓' : '—'}</td>
                <td style={st.td}>{r.activo ? <span style={st.on}>Activa</span> : <span style={st.off}>Baja</span>}</td>
                <td style={{ ...st.td, textAlign: 'right' }}>
                  <Boton variante="secondary" sm onClick={() => abrirEdit(r)}>Editar</Boton>
                  {r.activo && <Boton variante="destructive" sm style={{ marginLeft: 6 }} onClick={() => desactivar(r)}>Baja</Boton>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={st.modalBg}>
          <div style={st.modal} onClick={e => e.stopPropagation()}>
            <h3 style={{ marginTop: 0 }}>{modal === 'new' ? 'Nueva cuenta' : 'Editar cuenta'}</h3>
            <label style={st.lbl}>Código (Presea)</label>
            <input style={st.input} value={form.codigo} onChange={set('codigo')} />
            <label style={st.lbl}>Nombre</label>
            <input style={st.input} value={form.nombre} onChange={set('nombre')} />
            <label style={{ ...st.lbl, display: 'flex', alignItems: 'center', gap: 8, marginTop: 12 }}>
              <input type="checkbox" checked={!!form.pagable} onChange={e => setForm(f => ({ ...f, pagable: e.target.checked }))} /> Pagable (aparece en Pagos)
            </label>
            <label style={{ ...st.lbl, display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
              <input type="checkbox" checked={!!form.cobrable} onChange={e => setForm(f => ({ ...f, cobrable: e.target.checked }))} /> Cobrable (aparece en Cobranzas)
            </label>
            <label style={{ ...st.lbl, display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
              <input type="checkbox" checked={!!form.activo} onChange={e => setForm(f => ({ ...f, activo: e.target.checked }))} /> Activa
            </label>
            {err && <div style={st.err}>{err}</div>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 14 }}>
              <Boton variante="ghost" onClick={() => setModal(null)}>Cancelar</Boton>
              <Boton variante="primary" onClick={guardar} disabled={saving}>{saving ? '...' : 'Guardar'}</Boton>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const st = {
  wrap: { padding: '1.25rem', maxWidth: 900, margin: '0 auto' },
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  h1: { margin: 0, fontSize: '1.4rem', color: '#1e293b' },
  muted: { color: '#64748b', fontSize: '0.82rem' },
  card: { background: 'white', border: '1px solid #e2e8f0', borderRadius: 10, padding: 12 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' },
  th: { textAlign: 'left', padding: '0.5rem 0.6rem', borderBottom: '2px solid #e2e8f0', color: '#475569', fontWeight: 700, fontSize: '0.78rem' },
  tr: { borderBottom: '1px solid #f1f5f9' },
  td: { padding: '0.5rem 0.6rem', color: '#334155' },
  code: { background: '#f1f5f9', padding: '0 4px', borderRadius: 4, fontWeight: 700, fontSize: '0.78rem' },
  empty: { padding: '1rem', textAlign: 'center', color: '#94a3b8' },
  on: { color: '#166534', fontWeight: 600 }, off: { color: '#b91c1c', fontWeight: 600 },
  lbl: { display: 'block', fontSize: '0.72rem', color: '#64748b', margin: '8px 0 3px', fontWeight: 600 },
  input: { width: '100%', padding: '0.5rem 0.6rem', border: '1px solid #cbd5e1', borderRadius: 7, fontSize: '0.9rem', boxSizing: 'border-box' },
  err: { marginTop: 8, padding: '0.5rem 0.7rem', background: '#fee2e2', color: '#991b1b', borderRadius: 7, fontSize: '0.85rem' },
  modalBg: { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 },
  modal: { background: 'white', borderRadius: 12, padding: 18, width: 440, maxWidth: '100%' },
}
